import React, { useEffect, useState } from "react";

const APP = "Orignal2026";
const FALLBACK_VERSION = "0.71.0";

function envLabel(raw) {
  const value = String(raw || "").toUpperCase();
  if (value.includes("PROD")) return "PROD";
  if (value.includes("DEV") || value.includes("STAG")) return "DEV";
  if (value === "TEST" || value === "LOCAL" || !value) return "LOCAL";
  return value;
}

function shortCommit(value) {
  const text = String(value || "").trim();
  if (!text || text === "unknown" || text === "local") return "";
  return text.slice(0, 7);
}

export function PWSVersionBar({ appName = APP, environment, version, commit }) {
  const [info, setInfo] = useState({
    environment: environment || "LOCAL",
    version: version || FALLBACK_VERSION,
    commit: commit || "",
  });

  useEffect(() => {
    if (environment || version) return undefined;
    let stop = false;
    fetch("/api/health")
      .then((res) => (res.ok ? res.json() : null))
      .then((body) => {
        if (stop || !body) return;
        setInfo({
          environment: envLabel(body.env),
          version: body.semver || body.version || FALLBACK_VERSION,
          commit: shortCommit(body.commit || body.build_id),
        });
      })
      .catch(() => {});
    return () => {
      stop = true;
    };
  }, [environment, version]);

  const env = environment || info.environment;
  const ver = version || info.version;
  const sha = shortCommit(commit || info.commit);
  const shown = String(ver).startsWith("v") ? ver : `v${ver}`;
  const full = [appName, env, shown, sha].filter(Boolean).join(" · ");
  const compact = `${shown} · ${env}`;

  return (
    <footer className="pws-version-bar" data-testid="pws-version-bar" data-env={env} data-surface="dark">
      <span className="pws-version-bar__full">{full}</span>
      <span className="pws-version-bar__short">{compact}</span>
    </footer>
  );
}
